import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Breadcrumb from './Breadcrumb';
import BackToTop from './BackToTop';
import SkipLink from './SkipLink';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { pathname } = useLocation();
  // Home renders a full-bleed hero behind the transparent header, so it
  // intentionally has no spacer. Every other route reserves the fixed
  // header height so page content is never hidden underneath it.
  const isHome = pathname === '/';
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <SkipLink />
      <Header />
      {!isHome && (
        <div
          aria-hidden="true"
          className="h-24 lg:h-24 shrink-0"
          style={{ paddingTop: 'env(safe-area-inset-top)' }}
        />
      )}
      <Breadcrumb />
      <main
        id="main-content"
        tabIndex={-1}
        className="flex-1 focus:outline-none"
      >
        {children}
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default Layout;
